import React from 'react';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { StyledPeriodSwitcher } from '../index.style';

const PeriodSwitcher = ({ endDate, startDate }) => {
  const { t } = useTranslation();

  return (
    <StyledPeriodSwitcher style={{ gap: 4 }}>
      <Typography
        variant="body-20-medium"
        color={COLOR.descriptionUpload}
        style={{ display: 'flex', alignItems: 'center', gap: 4 }}
        className="text-period-switcher"
      >
        {t('descriptionHighlightsOfTheWeek')}
      </Typography>
      <Typography
        variant="body-20-semibold"
        color={COLOR.descriptionGray}
        style={{ display: 'flex', alignItems: 'center', gap: 4 }}
        className="text-period-switcher"
      >
        {moment(startDate).format('DD/MM/YYYY')} -{' '}
        {moment(endDate).format('DD/MM/YYYY')}
      </Typography>
    </StyledPeriodSwitcher>
  );
};

export default PeriodSwitcher;
